import { defineMessages } from 'react-intl';

export const messages: {
	resultLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	resultLabel: {
		id: 'dynamic-cards-search-page.github-pull-request-result.label',
		defaultMessage: 'Pull request',
		description:
			'GitHub pull request label shown as part of the pull request search result metadata, e.g. "Pull request • frontend-repository • Updated 2 days ago"',
	},
});
